export const cookiePolicyH2 = {
    fontSize: '36px',
    marginBottom: '10px',
    fontWeight: 500
}

export const cookiePolicyH2_1 = {
    fontSize: '20px',
    marginBottom: '10px',
    fontWeight: 600
}

export const cookiePolicyP = {
    lineHeight: '1.5'
}

export const customHrTag = {
    height: '1px',
    margin: '15px auto',
    color: '#0a0a0a33',
    backgroundColor: '#0a0a0a33',
    fontSize: 0,
    border: 0,
    boxsizing: 'content-box'
}

export const hyperLinkNoStyle = {
    color: '#003755',
    textDecoration: 'none',
    cursor: 'pointer'
}

export const CookieDeclarationType = {
    display: 'block',
    margin: '12px 0 12px 0',
    padding: '8px 8px 0 8px',
    border: '1px solid #333333',
    verticalAlign: 'top',
}

export const CookieDeclarationTable = {
    tableLayout: 'fixed',
    width: '100%',
    borderCollapse: 'collapse',
    borderSpacing: 0,
    margin: ' 0 0 18px 0',
    padding: '0',
    border: 0,
    fontSize: '100%',
    font: 'inherit',
    verticalAlign: 'baseline',
}

export const CookieDeclarationTableHeader = {
    fontWeight: 'bold',
    borderBottom: '1px solid #333333',
    textAlign: 'left',
    padding: '4px'
}

export const CookieDeclarationTableCell = {
    textOverflow: 'ellipsis',
    wordWrap: 'break-word',
    borderBottom: '1px solid #777777',
    verticalAlign: 'top',
    padding: '4px 4px 5px 4px'
}